<template>
    <div @click="moreBtn" style="cursor: pointer">
        <vs-card >
            <!-- Изображение клуба -->
            <div slot="media">
                <img
                    style="max-height: 300px; object-fit: cover"
                    :src="image"
                />
            </div>

            <div>
                <!-- Название -->
                <div class="flex justify-between">
                    <span class="title">{{ title }}</span>
                    <!-- Тип клуба -->
                    <span
                        style="
                            color: #545da7;
                            font-size: 14px;
                            font-weight: 600;
                        "
                        >{{ type }}</span
                    >
                </div>
                <!-- Статус -->
                <span class="mt-2">{{
                    status ? $t("closed1") : $t("public")
                }}</span>
            </div>
            <div class="flex justify-between items-center ">
                <div class="lg:flex items-center mt-4">
                    <ul class="users-liked user-list ml-2">
                        <li v v-for="el in participants" :key="el.id">
                            <vx-tooltip :text="el.student_profile.lastName	+ ' ' + el.student_profile.firstName" position="bottom">
                                <vs-avatar :src="el.student_profile.avatar" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                            </vx-tooltip>
                        </li>
                    </ul>
                    <small class="ml-2 text-sm">{{ participants.length  }} {{$t('participantss')}}</small>
                </div>
                <span class="mt-2 text-success"  v-if="subscibe"  style="
                            font-size: 12px;
                            font-weight: 600;
                        ">{{ $t('signed') }}</span>

            </div>
        </vs-card>
    </div>
</template>

<script>
export default {
    name: "ListCard",
    props: {
        image: [String],
        title: [String],
        description: [String],
        director: [String, Object],
        participants: [Array],
        type: [String],
        status: [String, Boolean],
        subscibe:[Boolean],
    },
    methods: {
        moreBtn() {
            this.$emit("eventMore");
        },
    },
};
</script>

<style scoped>
.title {
    font-size: 16px;
    font-weight: 500;
}
.text {
    font-size: 14px;
    font-weight: 300;
}
.text-medium {
    font-size: 12px;
    font-weight: 500;
}
.column {
    display: flex;
    flex-direction: column;
}
</style>
